import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tryAgain: {
		id: 'business-list.common.lazy-select-fetch-error.try-again',
		defaultMessage: 'Try again',
		description: 'Subtle link to reload the data',
	},
});
